<template>
<div class="modal-card">
  <header class="modal-card-head pop-header">
    <p class="modal-card-title tit">
      사용자별 사업장 권한
      <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
    </p>
  </header>
  <section class="modal-card-body pop-content">
    <div class="inner-box">
      <div class="content-name">
        <div class="btn-wrap btn-type1 clearfix" style="float: right; margin-top: -25px;">

          <button class="btn-size btn-w-gray" @click="buttonClickEventAddRow()" style="border: 1px solid; border-color: gray;">
            <span class="btn-icon">
              <i class="fas fa-plus"></i>
            </span>
            행추가
          </button>
          <button class="btn-size btn-w-gray" @click="buttonClickEventRemoveRow()" style="border: 1px solid; border-color: gray;">
            <span class="btn-icon">
              <i class="fas fa-trash-alt"></i>
            </span>
            행삭제
          </button>
          <button class="btn-size btn-blue fl_left" @click="buttonClickEventSave()">
            <span class="btn-icon"><i class="fas fa-save"></i></span>
            저장
          </button>
        </div>
      </div>

      <div class="table-area">
        <div class="table-b">
          <dhx-grid ref="grid" v-model="data" :config="config" @constructGridSuccessful="constructGridSuccessful" />
        </div>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import DhxGrid from '@/components/DhxGrid.vue'
import GridCheckbox from '@/components/grid/GridCheckbox.vue'
import assert from '@/libs/assert'
import GridSelect from "@/components/grid/GridSelect.vue";
import Vue from "vue";
import _ from "lodash";

const bus = new Vue()

const options = {
  'BUSINESS_AREA_CD': []
}
const mutex = {
  'BUSINESS_AREA_CD': false
}

function queryAreaSelectCd() {
  return new Promise((resolve, reject) => {
    if (mutex['BUSINESS_AREA_CD'] && options['BUSINESS_AREA_CD'].length > 0) {
      reject()
    } else {
      this.$store.commit('loading')
      this.$http.get('/api/code/combo', {
        params: {
          groupCd: 'BUSINESS_AREA_CD'
        }
      }).then(response => {
        options['BUSINESS_AREA_CD'] = response.data
        bus.$emit('OPTIONS.BUSINESS_AREA_CD', options['BUSINESS_AREA_CD'])
      }).finally(() => {
        this.$store.commit('finish')
      })
    }
  })
}

export default {
  props: {
    'empNo': {
      type: String,
      required: true
    },
    'empNm': {
      type: String,
      required: true
    },
    'compCd': {
      type: String,
      required: true
    }
  },
  components: {
    DhxGrid
  },
  data() {
    return {
      data: [],
      deleteList: [],
      memento: [],
      config: {
        columns: [{
          value: 'No.',
          type: 'cntr',
          width: 50
        }, {
          id: 'empNo',
          value: '사번',
        }, {
          id: 'empNm',
          value: '성명',
        }, {
          id: 'businessAreaCd',
          value: '조회권한',
          component: GridSelect,
          mixin: {
            data() {
              return {
                detailCd: 'key',
                detailNm: 'value'
              }
            },
            methods: {
              initializeRoleSelectCd() {
                this.options = options['BUSINESS_AREA_CD']
                if (Array.isArray(this.options) && this.options.length > 0) {
                  let found = this.options.filter(x => x[this.detailCd] === this.data)[0]
                  if (found === undefined) {
                    this.data = this.options[0][this.detailCd]
                    this.value[this.field] = this.data
                    this.$emit('input', this.value)
                  }
                }
                return function() {}
              }
            },
            created() {
              this.initializeRoleSelectCd()
              bus.$on('OPTIONS.BUSINESS_AREA_CD', () => {
                this.initializeRoleSelectCd()
              })
            }
          }
        }]
      }
    }
  },
  methods: {
    constructGridSuccessful(grid) {},
    query() {
      this.$store.commit('loading')
      this.$http.get('/api/auth/user/business', {
        params: {
          empNo: this.empNo
        }
      }).then(response => {
        this.data = response.data
        this.deleteList = []
        this.memento = []
      }).finally(() => {
        this.$store.commit('finish')
      })
    },
    save(callback) {
      try {
        // 권한코드 중복 체크
        let dupAreaCd = this.data.map(x => x.businessAreaCd).filter((x, i, arr) => arr.indexOf(x) === i)
        assert.apply(this, [dupAreaCd.length === this.data.length, '중복된 사업장은 허용되지 않습니다.'])

        // 삭제할 것이 있음
        if (this.deleteList.length > 0) {
          this.$store.commit('loading')
          let work = []
          _.forEach(this.deleteList, x => {
            work.push(this.$http.delete('/api/auth/area', {
              params: x
            }))
          })
          Promise.all(work)
                  .then(response => {
                    _proceed.apply(this, [callback])
                  }).catch(response => {
            console.error('Failed to remove Area authority')
          }).finally(() => {
            this.$store.commit('finish')
          });
        } else {
          _proceed.apply(this, [callback])
        }
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e
        })
      }

      function _proceed(callback) {
        this.$store.commit('loading')
        this.$http.put('/api/auth/area', this.data)
                .then(response => {
                  if (callback !== undefined && typeof callback === 'function') {
                    callback.apply(this, [])
                  } else {
                    this.$swal({
                      type: 'success',
                      text: '저장되었습니다.'
                    }).then(this.query)
                  }
                }).finally(() => {
          this.$store.commit('finish')
        })
      }
    },
    buttonClickEventSearch() {
      this.query()
    },
    buttonClickEventSave() {
      if (this.memento.length === 1) {
        this.$swal({
          type: 'warning',
          text: '저장할 내용이 없습니다.'
        })
      } else {
        this.save()
      }
    },
    buttonClickEventAddRow() {
      this.data.push({
        empNo: this.empNo,
        empNm: this.empNm,
        new: true
      })
    },
    buttonClickEventRemoveRow() {
      // 삭제할 행을 찾는다
      let rowId = this.$refs.grid.instance.getSelectedRowId()
      // 선택된 행이 없음
      if (rowId === null) {
        this.$swal({
          type: 'error',
          text: '삭제할 행을 선택해주세요.'
        })
      } else {
        let i = this.$refs.grid.instance.getRowIndex(rowId)
        let row = this.data[i]
        if (!this.data[i].new) {
          this.deleteList.push({
            empNo: this.data[i].empNo,
            compCd: this.data[i].compCd,
            businessAreaCd: this.data[i].businessAreaCd
          })
        }
        this.data.splice(i, 1)
      }
    }
  },
  created() {
      this.query()
      queryAreaSelectCd.apply(this, [])
  },
  watch: {
    'data': {
      deep: true,
      handler(value) {
        let exists = this.memento.indexOf(JSON.stringify(value))
        // Has history?
        if (exists >= 0) {
          // fallback
          this.memento.splice(exists, this.memento.length - exists + 1)
        } else {
          this.memento.unshift(JSON.stringify(value))
        }
      }
    }
  }
}
</script>
